<script lang="typescript">
    import ApexCharts from "apexcharts"
    import { onMount } from "svelte"

    let chartDiv

    export let items: PlanEntry[]
    export let users: User[]

    const countOfCustomers = new Set(
        items.map((i) => i.project?.customer_name || i.project?.customer?.name)
    ).size

    let chart

    onMount(() => {
        const options = {
            series: [],
            _s: [
                {
                    name: "Bob",
                    data: [
                        {
                            x: "Design",
                            y: [
                                new Date("2019-03-05").getTime(),
                                new Date("2019-03-08").getTime(),
                            ],
                        },
                        {
                            x: "Code",
                            y: [
                                new Date("2019-03-02").getTime(),
                                new Date("2019-03-05").getTime(),
                            ],
                        },
                        {
                            x: "Code",
                            y: [
                                new Date("2019-03-05").getTime(),
                                new Date("2019-03-07").getTime(),
                            ],
                        },
                        {
                            x: "Test",
                            y: [
                                new Date("2019-03-03").getTime(),
                                new Date("2019-03-09").getTime(),
                            ],
                        },
                        {
                            x: "Test",
                            y: [
                                new Date("2019-03-08").getTime(),
                                new Date("2019-03-11").getTime(),
                            ],
                        },
                        {
                            x: "Validation",
                            y: [
                                new Date("2019-03-11").getTime(),
                                new Date("2019-03-16").getTime(),
                            ],
                        },
                        {
                            x: "Design",
                            y: [
                                new Date("2019-03-01").getTime(),
                                new Date("2019-03-03").getTime(),
                            ],
                        },
                    ],
                },
                {
                    name: "Joe",
                    data: [
                        {
                            x: "Design",
                            y: [
                                new Date("2019-03-02").getTime(),
                                new Date("2019-03-05").getTime(),
                            ],
                        },
                        {
                            x: "Test",
                            y: [
                                new Date("2019-03-06").getTime(),
                                new Date("2019-03-16").getTime(),
                            ],
                            goals: [
                                {
                                    name: "Break",
                                    value: new Date("2019-03-10").getTime(),
                                    strokeColor: "#CD2F2A",
                                },
                            ],
                        },
                        {
                            x: "Code",
                            y: [
                                new Date("2019-03-03").getTime(),
                                new Date("2019-03-07").getTime(),
                            ],
                        },
                        {
                            x: "Deployment",
                            y: [
                                new Date("2019-03-20").getTime(),
                                new Date("2019-03-22").getTime(),
                            ],
                        },
                        {
                            x: "Design",
                            y: [
                                new Date("2019-03-10").getTime(),
                                new Date("2019-03-16").getTime(),
                            ],
                        },
                    ],
                },
                {
                    name: "Dan",
                    data: [
                        {
                            x: "Code",
                            y: [
                                new Date("2019-03-10").getTime(),
                                new Date("2019-03-17").getTime(),
                            ],
                        },
                        {
                            x: "Validation",
                            y: [
                                new Date("2019-03-05").getTime(),
                                new Date("2019-03-09").getTime(),
                            ],
                            goals: [
                                {
                                    name: "Break",
                                    value: new Date("2019-03-07").getTime(),
                                    strokeColor: "#CD2F2A",
                                },
                            ],
                        },
                    ],
                },
            ],
            chart: {
                height: countOfCustomers * 40 + 100,
                type: "rangeBar",
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: "80%",
                },
            },
            xaxis: {
                type: "datetime",
                position: "top",
            },
            /*dataLabels: {
                enabled: true,
                formatter(val, opts) {
                    const projectName =
                        opts?.w?.config?.series[opts?.seriesIndex]?.data[
                            opts?.dataPointIndex
                        ]?.projectName
                    console.log(projectName)
                    // return projectName
                },
            },*/
            stroke: {
                width: 1,
            },
            fill: {
                type: "solid",
                opacity: 0.6,
            },
            legend: {
                position: "top",
                horizontalAlign: "left",
            },
            annotations: {
                xaxis: [
                    {
                        x: new Date().getTime(),
                        borderColor: "#FF0000",
                        label: {
                            borderColor: "#00E396",
                            style: {
                                color: "#fff",
                                background: "#00E396",
                            },
                        },
                    },
                ],
            },
            tooltip: {
                enabled: true,
                y: {
                    formatter(d, opts) {
                        const projectName =
                            opts?.w?.config?.series[opts?.seriesIndex]?.data[
                                opts?.dataPointIndex
                            ]?.projectName
                        return d + " // " + projectName + " "
                    },
                },
            },
        }

        chart = new ApexCharts(chartDiv, options)
        chart.render()
    })

    $: if (chart) {
        chart.updateSeries(
            users?.map((u) => ({
                name: u.firstname,
                data: items
                    ?.filter((i) => i.user_id == u.id || i.user?.id == u.id)
                    .map((i) => ({
                        x:
                            i.project?.customer_name ||
                            i.project?.customer?.name /* +
                                " // " +
                                i.project?.name*/,
                        y: [
                            new Date(i.starts_on).getTime(),
                            new Date(i.ends_on + " 18:00:00").getTime(),
                        ],
                        projectName: i.project?.name,
                    })),
            })) || []
        )
    }
</script>

<div bind:this="{chartDiv}"></div>
